import { useAppSelector } from '../hooks';
import { selectActiveCopyJobForNewProject } from '@app/features/asyncJobs/asyncJobsSlice';
import type { AsyncJob, AsyncJobStatus } from '@app/features/asyncJobs/asyncJobsTypes';

export const useProjectCopyBlock = (projectId: number | undefined) => {
	const activeCopyJob = useAppSelector(state =>
		projectId ? selectActiveCopyJobForNewProject(state, projectId) : null
	);

	return {
		isBlocked: !!activeCopyJob,
		job: activeCopyJob,
		progress: activeCopyJob?.progress ?? 0,
		status: activeCopyJob?.status ?? null
	};
};

export type { AsyncJob, AsyncJobStatus };
